<div style=" background-color: #F3F3F5;width: 100%; height: auto; display: flex; justify-content: flex-end; padding: 0; margin: 0;">
    <button class="close-button" mat-dialog-close >
      <img src="./assets/images/close-icon.svg">
    </button>
</div>


<mat-dialog-content class="box-share-content">
  <div class="main-box-title-32" style="margin-bottom: 25px ;"> Share Projects</div>
  <div>
    <div class="main-box-title-18">Anyone with this link can view your project.</div>
    <div style="margin-top: 40px;">
    <label>Project Link</label>
    <div style="border: 1px solid #ccc; padding: 4px; border-radius: 4px; background-color: #f9f9f9;">
        <img id="img-link" src="./assets/images/link-icon.svg">
      <input type="text" [value]="shareLink" readonly class="box-input">
    </div>
    </div>
  </div>
  
  <div class="box-button">
  <button mat-button (click)="copyLink()" class="analysis-button">
    <img [src]="buttonImage" style="padding-right: 5px; width: 18px; vertical-align: middle; padding-bottom: 6px;">
    <span class="main-box-title-16" style="font-weight: 600;">
     {{ buttonText }}</span> </button>
  </div>
</mat-dialog-content>


